"use client";

import { useContext, useEffect } from "react";
import { isWindow } from "@/service/render-environment";
import { UserContext } from "@/contexts/user-context";
import { trans } from "@/service/i18n/i18n";
import { useEnvContext } from "next-runtime-env";

function getUserType(isLoggedin: boolean, type?: string) {
  if (!isLoggedin) {
    return trans("unlogged");
  }

  if (!type) {
    return trans("undefined");
  }

  return type;
}

export const GoogleDefaultAnalytics = () => {
  const { isLoggedIn, type, id } = useContext(UserContext);
  const { NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID } = useEnvContext();

  useEffect(() => {
    if (!isWindow() || !window?.dataLayer) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    if (isLoggedIn) {
      window.dataLayer?.push({
        event: "userIdentification",
        user_type: getUserType(isLoggedIn, type),
        user_id: id,
      } as never);
    } else {
      window.dataLayer?.push({
        user_type: getUserType(isLoggedIn, type),
      } as never);
    }

    function gtag() {
      window.dataLayer?.push(arguments as never);
    }

    gtag("js", new Date());

    gtag("config", NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID);
  }, []);

  return <></>;
};
